/**
 * Puts the dashboard's sources together. Pure, so the real path and the demo
 * path run the very same maths.
 */

import { aggregate, applyProcurement, variance } from "./buildDashboardLines";
import { applyLedger } from "./ledger";

/**
 * Estimate lines -> + linked POs / payments -> + entered budget / actual / paid,
 * then totals (with invoices per category) and variances.
 *
 * @param baseLines     buildDashboardLines() result
 * @param linked        linkProcurement() result, or null
 * @param invoices      extractInvoices() result ({} for none)
 * @param ledgerSummary summarizeLedger() result
 */
export const computeBoard = ({ baseLines, linked, invoices, ledgerSummary }) => {
  const lines = applyLedger(applyProcurement(baseLines, linked), ledgerSummary);
  const totals = aggregate(lines, invoices, ledgerSummary.invByCat);
  return { lines, totals, vars: variance(totals) };
};

// Anything recorded for Budget, Actual, Invoiced or Paid at all.
export const hasAnyMeasure = (totals) =>
  totals.has.bud || totals.has.act || totals.has.inv || totals.has.pd;

/** Every dated amount behind the four measures, for the S-curve. */
export const boardEvents = ({ linked, invoiceEvents, ledgerSummary }) => ({
  bud: ledgerSummary.events.bud,
  act: [...(linked?.events.act || []), ...ledgerSummary.events.act],
  inv: [...(invoiceEvents || []), ...ledgerSummary.events.inv],
  pd: [...(linked?.events.pd || []), ...ledgerSummary.events.pd],
});
